// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dEAw","col":"styles_col__2dy6o"};